module.exports = __webpack_public_path__ + "img/GAME_PICTURECORRECT2.de06281b.jpg";